import { render, staticRenderFns } from "./14.vue?vue&type=template&id=0831b760&"
import script from "./14.vue?vue&type=script&lang=js&"
export * from "./14.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports